module.exports = __webpack_public_path__ + "img/icon-egt-usdt.bf583799.png";